import { carePlanRequestsTyped } from "@/api/(requests)/carePlanTyped";
import type { PatientStrengthAndCautionOptionsResponse } from "@/core/types";

export async function getStrengthCautionOptions(
  patientId: string,
): Promise<PatientStrengthAndCautionOptionsResponse> {
  return carePlanRequestsTyped.get_patient_strength_and_caution_options({
    context: { showLoader: false },
    urlParams: { patientId },
  });
}
